import { Signal } from '@angular/core';
import { Project } from '@app/shared/types/models/project/project.model';
import { IdBased } from '@app/shared/types/models/shared/id-based.model';

export class CooperationProject implements IdBased {
  public id: string;
  public cooperationId: string;
  public project: Signal<Project | undefined>;

  public constructor(data: Partial<CooperationProject>) {
    Object.assign(this, data);
  }
}
